angular.module('ikeweb.user').controller('PremiumTileController', ['$scope', 'subscriptionActionService', 'events',
    function($scope, subscriptionActionService, events) {

        function update() {
            subscriptionActionService.canChangePlan().then(function(canChangePlan) {
                $scope.canChangePlan = canChangePlan;
            });
        }

        $scope.$on(events.SUBSCRIPTION.CANCELED, function() {
            $scope.closeCancelDialog();
        });

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], update);
        });

        update();
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/premium.tile.controller.js
// module id = 498
// module chunks = 0